export const LOAD_OPPORTUNITY_ACTIVITIES = 'LOAD_OPPORTUNITY_ACTIVITIES'
export const LOAD_EMAIL_ACTIVITY_TYPE_ENUM = 'LOAD_EMAIL_ACTIVITY_TYPE_ENUM'
export const LOAD_CALL_ACTIVITY_TYPE_ENUM = 'LOAD_CALL_ACTIVITY_TYPE_ENUM'
export const LOAD_ACTIVITY_TYPES = 'LOAD_ACTIVITY_TYPES'
